import PropTypes from 'prop-types';

import * as S from './styles';

export const InputErrorText = ({ error }) => {
    return <S.ErrorText>{error}</S.ErrorText>;
};

InputErrorText.propTypes = {
    error: PropTypes.string,
};
